'use client'

import type { Didomi } from '@/util/analytics'

import { waitForGppReady } from './gpp'
import { waitForTcfReady } from './tcf'

export type FreestarPrivacyFramework = 'none' | 'gpp' | 'tcf'

type PrivacyTarget = Pick<Window, '__gpp' | '__tcfapi'>

export function selectFreestarPrivacyFramework(didomi: Didomi): FreestarPrivacyFramework {
    let regulation: string | undefined
    try {
        regulation = didomi.getCurrentUserStatus?.().regulation
    } catch {
        return 'gpp'
    }

    switch (regulation?.trim().toUpperCase()) {
        case 'GDPR':
            return 'tcf'
        case 'NONE':
            return 'none'
        default:
            return 'gpp'
    }
}

export function waitForFreestarPrivacyReady(didomi: Didomi, target: PrivacyTarget = window): Promise<void> {
    const framework = selectFreestarPrivacyFramework(didomi)
    if (framework === 'tcf') {
        return waitForTcfReady(target)
    }

    if (framework === 'none') {
        return Promise.resolve()
    }

    return waitForGppReady(target).then(() => undefined)
}
